<template>
    <div>
      <md-dialog :md-active="showDialog" :md-backdrop-close="false" :md-esc-close="false">
        <div class="encabezado text-center">
          <img src="../../isep/Tools/check.gif" alt="" class="gif">
          <!-- <i class="far fa-check-circle fa-9x p-4" style="color: white;"></i> -->
        </div>
        <div class="p-3 text-center">
            <h4>E X I T O!</h4>
            <p v-html="mensaje"></p>
            <md-button class="md-primary buton-alert col-6" @click="closeModal">Continuar</md-button>
        </div>
      </md-dialog>
    </div>
  </template>
  
  <script>
    export default {
      name: 'DialogCustom',
      props:{
        showDialog: Boolean,
        mensaje: String,
        reloadPage: Boolean
      },
      data: () => ({}),
      methods: {
        closeModal(){
          if (this.reloadPage) {
            window.location.reload();
          } else {
            this.showDialog = false
          }
        }
      }
    }
  </script>
  
  <style lang="scss" scoped>
    .md-dialog /deep/.md-dialog-container {
      width: 400px;
      border-radius: 30px;
    }
    .buton-alert{
        background-color: #32d35b;
        color: white !important;
    }
    .encabezado{
      background-color: #a6e4bd;
    }
    .gif{
      height: 3rem;
    }

  </style>